import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export const BILLABLE_LOCK_EVENT = 'easypost:billable-lock';

/**
 * Prevents dismissing the current page while an upstream billable request may
 * still be settling. The caller must keep its retry state durable separately.
 */
export function useBillableNavigationLock(locked: boolean): void {
  const blocker = useBlocker(locked);

  useEffect(() => {
    if (blocker.state === 'blocked') blocker.reset();
  }, [blocker]);

  useEffect(() => {
    if (!locked) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.dispatchEvent(new CustomEvent(BILLABLE_LOCK_EVENT, { detail: true }));

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.dispatchEvent(new CustomEvent(BILLABLE_LOCK_EVENT, { detail: false }));
    };
  }, [locked]);
}
